export default __webpack_public_path__ + "static/media/jcb.f8bc70ae.svg";